/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservationCreditPurchasesPathParameters } from 'api/actions/get-reservation-credit-purchases/get-reservation-credit-purchases-path-parameters';
import { GetReservationCreditPurchasesResponse } from 'api/actions/get-reservation-credit-purchases/get-reservation-credit-purchases-response';

type GetReservationCreditPurchasesQueryParameters = Record<string, any>;

/**
 * The path of the GetReservationCreditPurchases action.
 */
export const getReservationCreditPurchasesActionPath = new SweetPath<keyof GetReservationCreditPurchasesPathParameters>(
  '/reservations/credits/purchases',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservationCreditPurchases actions.
 */
export default function createGetReservationCreditPurchasesAction(axios: AxiosInstance) {
  return function getReservationCreditPurchasesAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetReservationCreditPurchasesQueryParameters } = {}) {
    const path = getReservationCreditPurchasesActionPath.original;

    return axios.get<GetReservationCreditPurchasesResponse, GetReservationCreditPurchasesResponse>(path, {
      params: query,
      headers,
    });
  };
}
